import {
  SyncOutlined,
  CheckCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import { useAppTranslation } from "~/hooks/useAppTranslation";
import * as APITypes from "~/API";

export const LeaseStatusTag = ({
  status,
}: {
  status: APITypes.LeaseStatusType;
}) => {
  const { t } = useAppTranslation();
  let color = "grey";
  let icon = <SyncOutlined />;
  let statusText = t("Created");

  switch (status) {
    case APITypes.LeaseStatusType.Active: {
      color = "green";
      icon = <CheckCircleOutlined />;
      statusText = t("Active");
      break;
    }
    case APITypes.LeaseStatusType.Terminating: {
      color = "yellow";
      icon = <StopOutlined />;
      statusText = t("Terminating");
      break;
    }
    case APITypes.LeaseStatusType.Expired: {
      color = "yellow";
      icon = <StopOutlined />;
      statusText = t("Expired");
      break;
    }
    case APITypes.LeaseStatusType.Terminated: {
      color = "yellow";
      icon = <StopOutlined />;
      statusText = t("Cancelled");
      break;
    }

    case APITypes.LeaseStatusType.Rejected: {
      color = "yellow";
      icon = <StopOutlined />;
      statusText = t("Rejected");
      break;
    }
  }

  return (
    <Tag color={color} icon={icon}>
      {statusText}
    </Tag>
  );
};
